export default {
  SHOW_LOGIN: 'SHOW_LOGIN',
  SHOW_REGISTER: 'SHOW_REGISTER',
  SHOW_RESET_PASSWORD: 'SHOW_RESET_PASSWORD',
  HIDE: 'HIDE',
  REGISTER: {
    pending: 'REGISTER/pending',
    fulfilled: 'REGISTER/fulfilled',
    rejected: 'REGISTER/rejected',
  },
  LOGIN: {
    pending: 'LOGIN/pending',
    fulfilled: 'LOGIN/fulfilled',
    rejected: 'LOGIN/rejected',
  },
  LOGOUT: {
    pending: 'LOGOUT/pending',
    fulfilled: 'LOGOUT/fulfilled',
    rejected: 'LOGOUT/rejected',
  },
  GET_USER_INFO: {
    pending: 'GET_USER_INFO/pending',
    fulfilled: 'GET_USER_INFO/fulfilled',
    rejected: 'GET_USER_INFO/rejected',
  },
  RESET_PASSWORD_SEND_EMAIL: {
    pending: 'RESET_PASSWORD_SEND_EMAIL/pending',
    fulfilled: 'RESET_PASSWORD_SEND_EMAIL/fulfilled',
    rejected: 'RESET_PASSWORD_SEND_EMAIL/rejected',
  },
  RESET_PASSWORD_CHECK_HASH: {
    pending: 'RESET_PASSWORD_CHECK_HASH/pending',
    fulfilled: 'RESET_PASSWORD_CHECK_HASH/fulfilled',
    rejected: 'RESET_PASSWORD_CHECK_HASH/rejected',
  },
  RESET_PASSWORD_CONFIRM: {
    pending: 'RESET_PASSWORD_CONFIRM/pending',
    fulfilled: 'RESET_PASSWORD_CONFIRM/fulfilled',
    rejected: 'RESET_PASSWORD_CONFIRM/rejected',
  },
}


// WEBPACK FOOTER //
// ./src/app/containers/Auth/ActionTypes.js